import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Camera, CheckCircle2, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DocUpload = ({ label, value, onChange, testid, onFile = false }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await axios.post(`${API}/upload`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success(`${label} uploaded.`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed — please try again.");
    } finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <div className={`flex items-center gap-3 rounded-md border px-3 py-2.5 ${value === "onfile" ? "border-green-500/30 bg-green-500/5" : value ? "border-green-500/30 bg-green-500/5" : "border-white/15 bg-black/30"}`}>
      {value ? <CheckCircle2 size={16} className="text-green-400 shrink-0" /> : <Camera size={16} className="text-white/40 shrink-0" />}
      <div className="min-w-0 flex-1">
        <div className="text-white text-sm font-semibold truncate">{label}</div>
        <div className="text-xs text-white/40">{value === "onfile" ? "Already on file with AutoHire ✓ — no upload needed" : value ? "Uploaded ✓" : "Photo or image file, max 12MB"}</div>
      </div>
      {value !== "onfile" && (
        <button type="button" data-testid={testid} onClick={() => ref.current?.click()} disabled={busy}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-[#F2B705]/15 border border-[#F2B705]/30 text-[#F2B705] text-xs font-bold disabled:opacity-50 shrink-0">
          {busy ? <Loader2 size={12} className="animate-spin" /> : value ? <RefreshCw size={12} /> : <Camera size={12} />}
          {busy ? "Uploading…" : value ? "Replace" : "Upload"}
        </button>
      )}
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} />
    </div>
  );
};
